<template>
	<div>
        <div v-if="showHeader" class="mb-3 flex items-center justify-between border-b border-gray-200 pb-2">
        	<div class="flex items-center">
				<h1 class="module-header">Building Information</h1>
				<span class="ml-4 inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-sm font-medium text-green-700 ring-1 ring-inset ring-green-600/20">{{ building.type.type }}</span>
			</div>
            <button v-if="canEditBuilding() && ! fromReatlas" @click="launchEditBuilding" type="button" class="btn btn-small btn-indigo flex items-center">
                <inline-svg name="edit" classes="w-4 h-4 text-white fill-current"></inline-svg>
                <span class="ml-2">Edit Building</span>
            </button>
        </div>
	    <div
	    	v-if="buildingFields.length"
	    	class="w-full flex  printing:flex-col"
	    	:class="fromReatlas ? 'flex-col': 'md:flex-row'">
				<div
					class="w-full printing:w-full p-4 bg-gray-100 border rounded-sm shadow-md"
					:class="{ 'md:w-4/5': ! fromReatlas }">
					<div
						class="grid grid-cols-2 printing:grid-cols-3 gap-x-4 gap-y-3"
						:class="fromReatlas ? 'lg:grid-cols-3' : 'lg:grid-cols-3 xl:grid-cols-4'">
							<div v-for="(row, rowIndex) in buildingFields" :key="rowIndex">
								<div class="h-full px-5 py-4 flex flex-col items-center justify-center bg-white rounded border border-gray-200 text-center">
									<p class="text-lg font-bold">
										<span v-if="building[row.field] == null">-</span>
										<span v-else-if="row.type == 'integer' || row.type == 'double'">
											{{ building[row.field] | number(row.type == 'double' ? 1 : 0) }}
										</span>
										<span v-else-if="row.type == 'currency'" data-precision="2" :data-originalvalue="building[row.field] * 100" class="is-currency">
											{{ formatCurrency(building[row.field] * 100, 2) }}
										</span>
										<span v-else-if="row.type == 'percentage'">
											{{ building[row.field] | number }}%
										</span>
										<span v-else>{{ building[row.field] || '-' }}</span>
									</p>
									<p class="text-gray-500 leading-5 font-variant-all-small-caps font-semibold">{{ row.label }}</p>
								</div>
							</div>
					</div>
				</div>

			<div
				class="mt-5 printing:mt-5 printing:ml-0 px-6 py-8 w-full printing:w-full bg-gray-100 border rounded-md shadow-md"
				:class="fromReatlas ? 'mt-5' : 'md:mt-0 md:ml-3 md:w-1/5'">
				<div
					class="grid printing:grid-cols-4 gap-x-4 printing:gap-y-5"
					:class="fromReatlas ? 'grid-cols-3' : 'md:grid-cols-1'">
						<div v-for="(row, rowIndex) in buildingToggleFields" :key="rowIndex" class="mb-6 printing:mb-0 flex items-center leading-5">
							<div>
								<inline-svg v-if="building[row.field]" name="check" classes="w-4 lg:w-7 fill-current text-green-500"></inline-svg>
								<inline-svg v-else name="x" classes="w-4 lg:w-7 fill-current text-red-500"></inline-svg>
							</div>
							<label :for="row.field" class="ml-2 mb-0 pt-0 block text-xs md:text-lg font-medium text-gray-700">{{ row.label }}</label>
						</div>
				</div>
			</div>
	    </div>

        <modal name="manage-units" width="50%" height="auto" draggable=".modal-header">
            <manage-units></manage-units>
        </modal>
	</div>
</template>

<script>
    export default {
    	props: {
    		buildingData: {
    			type: Object,
    			required: true
    		},

			showHeader: {
				type: Boolean,
				default: true
			},

            fromReatlas: {
                type: Boolean,
                default: false
            },

            fromSiteId: {
                type: Number,
                required: false
            }
    	},

    	data() {
    		return {
    			buildingTypes: {}
    		}
    	},

        created() {
            this.initBuildingTypes();
        },

		computed: {
			building() {
				return this.buildingData;
			},

			buildingFields() {
				if (this.buildingTypes.length && this.building.type_id != null) {
					let fields = _.clone(_.find(this.buildingTypes, ['id', this.building.type_id]).fields);

					return _.remove(fields, (field) => {
						return field.type != 'boolean'
					});
				}

				return [];
			},

			buildingToggleFields() {
				if (this.buildingTypes.length && this.building.type_id != null) {
					let fields = _.find(this.buildingTypes, ['id', this.building.type_id]).fields;

					return _.remove(fields, (field) => {
						return field.type == 'boolean'
					});
				}

				return [];
			}
		},

        methods: {
            initBuildingTypes() {
                axios.get('/api/building-types').then((response) => {
                    this.buildingTypes = response.data.types;
                }).catch((error) => {
                    console.log(error);
                });
            },

            launchEditBuilding() {
            	window.location = '/buildings/' + this.building.id + '/edit' + (! isNaN(this.fromSiteId) ? '?siteId=' + this.fromSiteId : '');
            },

			canEditBuilding() {
				return this.$gate.can('edit', 'site', this.site);
			}
        }
    }
</script>
